import { Component, OnInit, OnDestroy, ViewChild, ElementRef, DoCheck, AfterViewInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { SidenavService } from 'src/app/services/sidenav.service';
import { AppStateProvider } from 'src/app/services/app-state.provider';
import { Subscription } from 'rxjs';
import { NgbModal, ModalDismissReasons, NgbCalendar, NgbDate, NgbDateAdapter, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { Dimensions, ImageCroppedEvent, ImageTransform } from 'ngx-image-cropper';
import { DomSanitizer } from '@angular/platform-browser';
import { Foodcourt } from 'src/app/model/foodcourt.model';
import { AddfoodvendorService } from 'src/app/services/addfoodvendor.service';
import { FoodcourtService } from 'src/app/services/foodcourt.service';
import { DateService } from 'src/app/services/date.service';
import { CommonService } from 'src/app/services/common.service';
import { ReviewremoveflagComponent } from 'src/app/modal/review-remove-flag/review-remove-flag.component';
import { HidevendorreviewComponent } from 'src/app/modal/hide-vendor-review/hide-vendor-review.component';
import { RolebasedactionService } from 'src/app/services/rolebasedaction.service';

@Component({
  standalone: false,
  selector: 'app-vendor-reviews',
  templateUrl: './vendor-reviews.component.html',
  styleUrls: ['./vendor-reviews.component.scss']
})
export class VendorReviewsComponent implements OnInit {

  public foodcourt = new Foodcourt();
  private subscriptions = new Subscription();

  page: any;
  totalPages = 1;
  indexPage = 1;
  pageNo: number = 0;
  pageSize: number = 20;
  totalRows: number = 0;
  searchText: string = '';
  parkId: any;
  showDropdown: boolean = false;
  totalCount;
  displayCount;
  mainReviewList: any[] = [];
  newmainReviewList: any[] = [];
  newmainReviewListReported = [];
  newmainReviewListHide = [];
  reviewDeepCopy: any;
  newMainReviews: any;
  reviewTempNew: any;
  masterSelectedReview: boolean;
  checkedReviewList: any;
  checkedOnlyReviewList: any;
  onlyReviewIds = [];
  selectedReviewName: any;
  selectedReviewFilterName: any;
  mainReviewTypes: any[] = [];
  mainReviewFilterTypes: any[] = [];
  searchGroup: string = '';
  multiSelectGroup: any;
  multiSelectGroupFilter: any;
  searchReviewList = [];
  closedType: any;
  singleReviewDataDelete = [];
  vendorId: any;
  ratingArray = [];
  ratingArrayOff = [];
  ratingFullArray = [0, 1, 2, 3, 4, 5];
  ratingFullArrayImage = [0, 1, 2, 3, 4, 5];
  keyWord: any;
  isHide: any;
  foodvendorApprove: any;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private sideNavService: SidenavService,
    private appStateSrv: AppStateProvider,
    private modalService: NgbModal,
    private sanitizer: DomSanitizer,
    private acroute: ActivatedRoute,
    private dateAdapter: NgbDateAdapter<string>,
    private dateSrv: DateService,
    private addfoodvendorService: AddfoodvendorService,
    private foodcourtService: FoodcourtService,
    private commonService: CommonService,
    private route: ActivatedRoute,
    private rolebasedactionService: RolebasedactionService,
  ) {
    localStorage.setItem('expandNavFoodCourt', 'true');
    const routeLink = this.sideNavService.routingChunks({
      name: 'Food Court Management',
      subNav: '1',
      subNavLink: '',
    });
    this.appStateSrv.setSideNavState(routeLink);
  }

  ngOnInit(): void {
    this.foodvendorApprove = this.rolebasedactionService.checkUserRolePermissionExits('Food Court:Approve');
    localStorage.removeItem('expandNav');
    localStorage.removeItem('expandNavLand');
    localStorage.removeItem('expandNavCreateview');

    this.route.params.subscribe((params) => {
      this.vendorId = params['id'];
    });

    this.totalRows = 0;
    this.pageNo = 0;
    this.pageSize = 20;
    this.page = 0;
    this.indexPage = 1;

    this.getTheReviewList();
    this.getTheReportedGroupList();
    this.getTheFilteredGroupList();
  }

  ngOnDestroy() {
    localStorage.removeItem('expandNavFoodCourt');
    this.subscriptions.unsubscribe();
  }

  openPopover(popover) {
    if (popover.isOpen()) {
      popover.close();
    } else {
      popover.open();
    }
  }

  openPopoverReceived(popover) {
    if (popover.isOpen()) {
      popover.close();
    } else {
      popover.open();
    }
  }

  onClickedOutside(e: Event) {
    console.log('Clicked outside:', e);
  }

  paginationCount(val: number) {
    return val % 10 == 0 ? Math.floor(val / 10) : Math.floor(val / 10) + 1;
  }

  searchByText(event: any) {
    if (!event || event === '') {
      // Reset to original list
      if (this.multiSelectGroup == 'All') {
        this.newmainReviewList = this.mainReviewList;
      } else {
        if (this.searchReviewList.length > 0) {
          this.newmainReviewList = this.searchReviewList;
        } else {
          this.newmainReviewList = this.mainReviewList;
        }
      }
      this.totalRows = this.newmainReviewList?.length;
      return;
    }

    // Filter based on search text
    const searchLower = event.toLowerCase();
    let sourceList: any[] = [];

    if (this.searchReviewList.length > 0) {
      sourceList = this.searchReviewList;
    } else {
      sourceList = this.mainReviewList;
    }

    this.newmainReviewList = sourceList.filter((item: { reviewDescription: any }) => {
      if (!item || !item.reviewDescription) return false;
      return item.reviewDescription.toLowerCase().includes(searchLower);
    });
    this.totalRows = this.newmainReviewList?.length;
  }

  getFilteredReviewTypes(): any[] {
    if (!this.mainReviewTypes || !Array.isArray(this.mainReviewTypes)) {
      return [];
    }
    if (!this.searchGroup || this.searchGroup === '') {
      return this.mainReviewTypes;
    }
    const searchLower = this.searchGroup.toLowerCase();
    return this.mainReviewTypes.filter((item: any) => {
      if (!item || !item.reviewTypeName) return false;
      return item.reviewTypeName.toLowerCase().includes(searchLower);
    });
  }

  getFilteredReviewFilterTypes(): any[] {
    if (!this.mainReviewFilterTypes || !Array.isArray(this.mainReviewFilterTypes)) {
      return [];
    }
    if (!this.searchGroup || this.searchGroup === '') {
      return this.mainReviewFilterTypes;
    }
    const searchLower = this.searchGroup.toLowerCase();
    return this.mainReviewFilterTypes.filter((item: any) => {
      if (!item || !item.reviewTypeFilterName) return false;
      return item.reviewTypeFilterName.toLowerCase().includes(searchLower);
    });
  }

  handelReviewList(event: any) {
    console.log(event);
    this.page = event;
    this.indexPage = this.page;
    // this.getVegitationPlantList();
  }

  checkUncheckAll() {
    for (var i = 0; i < this.newmainReviewListReported.length; i++) {
      this.newmainReviewListReported[i].isSelected = this.masterSelectedReview;
    }
    this.getCheckedItemList();
    console.log(this.masterSelectedReview);
    if (this.masterSelectedReview === false) {
      this.showDropdown = false;
    }
  }

  // Check All Checkbox Checked
  isAllSelected() {
    this.showDropdown = false;
    this.masterSelectedReview = this.newmainReviewListReported.every(function (item: any) {
      return item.isSelected === true;
    });
    console.log(this.masterSelectedReview);
    this.getCheckedItemList();
  }

  getCheckedItemList() {

    this.checkedReviewList = [];
    this.checkedOnlyReviewList = [];
    this.onlyReviewIds = [];

    for (var i = 0; i < this.newmainReviewListReported?.length; i++) {

      if (this.newmainReviewListReported[i].isSelected) {
        this.checkedReviewList.push(this.newmainReviewListReported[i]);
        this.checkedOnlyReviewList.push(this.newmainReviewListReported[i]);
        this.showDropdown = true;
      }
    }

    for (var j = 0; j < this.checkedOnlyReviewList?.length; j++) {
      this.onlyReviewIds.push(this.checkedOnlyReviewList[j].foodCourtVendorReviewId);
    }

    console.log(this.onlyReviewIds);
    this.checkedReviewList = JSON.stringify(this.checkedReviewList);

  }

  getTheReviewList() {

    const userListPagination = {
      start: (this.page - 1) * this.pageSize, //this.page,
      offset: this.pageSize,
    };

    this.parkId = localStorage.getItem('parkId');

    this.foodcourtService.getVendorReviewList(this.vendorId).subscribe((res) => {
      if (res?.isValid === true) {
        this.mainReviewList = res?.data.foodCourtVendorReviewList;
        // this.newmainSurveyList = res?.data.foodCourtVendorReviewList;
        this.newmainReviewList = res?.data.foodCourtVendorReviewList.filter((item: { isActive: any }) => {
          return item.isActive === true;
        });
        this.newmainReviewListReported = res?.data.foodCourtVendorReviewList.filter((item: { isFlagReview: any, isFlagRemove: any }) => {
          return (item.isFlagRemove === null && item.isFlagReview === true);
        });
        this.newmainReviewListHide = res?.data.foodCourtVendorReviewList.filter((item: { isReviewHide: any, isFlagReview: any }) => {
          return (item.isReviewHide === true && item.isFlagReview === true);
        });

        // for (let i = 0; i <= this.newmainReviewList.length - 1; i++) {
        //   console.log(this.newmainReviewList[i].userVendorRating);
        //   this.ratingArray = [];
        //   for (let k = 0; k <= this.newmainReviewList[i].userVendorRating - 1; k++) {
        //     this.ratingArray.push({
        //       ratingCount: k + 1,
        //       starImage: '../../../assets/images/rating-star-single.png',
        //       starImageOff: '../../../assets/images/rating-star-single-grey.png',
        //     });
        //   }
        //   this.ratingArrayOff = [];
        //   for (let j = 0; j <= 5 - this.newmainReviewList[i].userVendorRating - 1; j++) {
        //     this.ratingArrayOff.push({
        //       ratingCount: j + 1,
        //       starImage: '../../../assets/images/rating-star-single.png',
        //       starImageOff: '../../../assets/images/rating-star-single-grey.png',
        //     });
        //   }
        // }

        console.log(this.newmainReviewList);
        this.newMainReviews = res.data;
        this.reviewDeepCopy = JSON.parse(JSON.stringify(res.data));
        this.reviewTempNew = res?.data.foodCourtVendorReviewList;
        this.totalRows = res?.data.foodCourtVendorReviewList.length;
      } else {
        this.mainReviewList = [];
        this.newmainReviewList = [];
        this.totalRows = 0;
      }
    });

    for (var i = 0; i < this.mainReviewList?.length; i++) {
      this.mainReviewList[i].isSelected = false;
    }

    console.log(this.mainReviewList);
    this.getCheckedItemList();
  }


  getTheReportedGroupList() {

    this.mainReviewTypes.push(
      {
        reviewTypeId: null,
        reviewTypeName: "Reported"
      },
      {
        reviewTypeId: null,
        reviewTypeName: "Mark as Helpful"
      }
    );
    const allOpt = {
      reviewTypeId: null,
      reviewTypeName: "All"
    }
    this.mainReviewTypes.unshift(allOpt);
    this.selectedReviewName = this.mainReviewTypes[0].reviewTypeName;
  }

  selectReviewType(item) {

    console.log(item);

    this.selectedReviewName = item.reviewTypeName;

    if (item.reviewTypeName !== null) {
      if (this.multiSelectGroup == item.reviewTypeName) {
        this.multiSelectGroup.splice(this.multiSelectGroup.indexOf(item.reviewTypeName), 1);
      } else {
        this.newMainReviews.foodCourtVendorReviewList = this.reviewDeepCopy.foodCourtVendorReviewList;
        this.multiSelectGroup = item.reviewTypeName;
      }
    }
    else {
      this.multiSelectGroup = 'All';
    }

    console.log(this.multiSelectGroup);

    if (this.multiSelectGroup == 'Reported') {
      this.closedType = true;
    } else {
      this.closedType = false;
    }

    console.log(this.closedType);

    if (this.multiSelectGroup != '') {
      if (this.multiSelectGroup == 'All') {
        // this.newmainReviewList = this.reviewDeepCopy.foodCourtVendorReviewList;
        this.newmainReviewList = this.mainReviewList.filter((item) => {
          return (item.reviewDescription != '');
        });
      } else if (this.multiSelectGroup == 'Mark as Helpful') {
        this.newmainReviewList = this.mainReviewList.filter((item) => {
          return (item.isFlagRemove === true && (item.isFlagReview === true || item.isFlagReview === false));
        });
      } else {
        this.newmainReviewList = this.mainReviewList.filter((item) => {
          return (item.isFlagRemove === null && item.isFlagReview === true);
        });
      }
    } else {
      this.newmainReviewList = this.reviewDeepCopy.foodCourtVendorReviewList;
    }

    this.searchReviewList = this.newmainReviewList;

    this.totalRows = this.newmainReviewList.length;
    this.totalCount = this.newmainReviewList.length;
    this.displayCount = Math.ceil(this.totalCount / this.pageSize);

    console.log(this.multiSelectGroup);

    // if (this.multiSelectGroup != '') {
    //   this.selectedVendorName = this.mainVendorList.filter(group => group.isMarkClosed === this.closedType)[0].isMarkClosed;
    // } else {
    //   this.selectedVendorName = this.mainVendorList[0].isMarkClosed;
    // }
  }

  getTheFilteredGroupList() {

    this.mainReviewFilterTypes.push(
      {
        reviewTypeFilterId: 'this_week',
        reviewTypeFilterName: "This Week"
      },
      {
        reviewTypeFilterId: 'last_week',
        reviewTypeFilterName: "Last Week"
      },
      {
        reviewTypeFilterId: 'this_month',
        reviewTypeFilterName: "This Month"
      },
      {
        reviewTypeFilterId: 'last_month',
        reviewTypeFilterName: "Last Month"
      }
    );
    const allOpt = {
      reviewTypeFilterId: null,
      reviewTypeFilterName: "All"
    }
    this.mainReviewFilterTypes.unshift(allOpt);
    this.selectedReviewFilterName = this.mainReviewFilterTypes[0].reviewTypeFilterName;
  }

  selectFilterType(item) {

    console.log(item);

    this.selectedReviewFilterName = item.reviewTypeFilterName;

    if (item.reviewTypeFilterName !== null) {
      if (this.multiSelectGroupFilter == item.reviewTypeFilterName) {
        this.multiSelectGroupFilter.splice(this.multiSelectGroupFilter.indexOf(item.reviewTypeFilterName), 1);
      } else {
        this.newMainReviews.foodCourtVendorReviewList = this.reviewDeepCopy.foodCourtVendorReviewList;
        this.multiSelectGroupFilter = item.reviewTypeFilterName;
      }
    }
    else {
      this.multiSelectGroupFilter = 'All';
    }

    if (item.reviewTypeFilterId == null) {
      this.keyWord = 'all';
    } else {
      this.keyWord = item.reviewTypeFilterId;
    }

    this.foodcourtService.vendorReviewFilterData(this.vendorId, this.keyWord).subscribe((res) => {
      if (res?.isValid === true) {
        this.mainReviewList = res?.data.foodCourtVendorReviewList;
        // this.newmainSurveyList = res?.data.foodCourtVendorReviewList;
        this.newmainReviewList = res?.data.foodCourtVendorReviewList.filter((item: { isActive: any }) => {
          return item.isActive === true;
        });
        this.newmainReviewListReported = res?.data.foodCourtVendorReviewList.filter((item: { isFlagReview: any, isFlagRemove: any }) => {
          return (item.isFlagRemove === null && item.isFlagReview === true);
        });
        this.newmainReviewListHide = res?.data.foodCourtVendorReviewList.filter((item: { isReviewHide: any, isFlagReview: any }) => {
          return (item.isReviewHide === true && item.isFlagReview === true);
        });
        console.log(this.newmainReviewList);
        this.newMainReviews = res.data;
        this.reviewDeepCopy = JSON.parse(JSON.stringify(res.data));
        this.reviewTempNew = res?.data.foodCourtVendorReviewList;
        this.totalRows = res?.data.foodCourtVendorReviewList.length;
      } else {
        this.mainReviewList = [];
        this.newmainReviewList = [];
        this.totalRows = 0;
      }
    });

    this.totalRows = this.newmainReviewList.length;
    this.totalCount = this.newmainReviewList.length;
    this.displayCount = Math.ceil(this.totalCount / this.pageSize);

    console.log(this.multiSelectGroupFilter);

    // if (this.multiSelectGroupFilter != '') {
    //   this.selectedReviewFilterName = this.mainReviewList.filter(group => group.isMarkClosed === this.closedType)[0].isMarkClosed;
    // } else {
    //   this.selectedReviewFilterName = this.mainReviewList[0].isMarkClosed;
    // }
  }

  openModalRemoveReviewFlag(id: any): void {
    console.log(id);
    this.singleReviewDataDelete = [];
    const modalOptions: NgbModalOptions = {
      size: 'md',
    };
    const modalRef = this.modalService.open(ReviewremoveflagComponent, modalOptions);
    modalRef.componentInstance.reviewId = id;
  }

  openModalHideReview(id: any, value: any): void {
    console.log(id);
    this.singleReviewDataDelete = [];
    const modalOptions: NgbModalOptions = {
      size: 'md',
    };
    const modalRef = this.modalService.open(HidevendorreviewComponent, modalOptions);
    modalRef.componentInstance.reviewId = id;
    modalRef.componentInstance.hideUnhideValue = value;
    modalRef.componentInstance.reviewHideType = 'bulk_hide';
  }

  openModalHideReviewSingle(id: any, value: any): void {
    console.log(id[0]);
    if (value == 'hide') {
      this.isHide = true;
    } else {
      this.isHide = false;
    }
    this.singleReviewDataDelete = [];
    this.singleReviewDataDelete.push({
      "FoodCourtVendorReviewId": id[0],
      "IsReviewHide": this.isHide,
      "ReviewHideBy": localStorage.getItem('claAdminId'),
    });
    console.log(this.singleReviewDataDelete[0]);
    const modalOptions: NgbModalOptions = {
      size: 'md',
    };
    const modalRef = this.modalService.open(HidevendorreviewComponent, modalOptions);
    modalRef.componentInstance.reviewId = this.singleReviewDataDelete[0];
    modalRef.componentInstance.hideUnhideValue = value;
    modalRef.componentInstance.reviewHideType = 'single_hide';
  }

}
